import analyticsMixin from "@/mixins/analytics-mixin";
import router from "@/router";
import { routeData } from "@/router/constants/routes";

export function sendToReturnUser() {
    analyticsMixin.methods.initSession();

    router.push({
        name: routeData.RETURN_USER.name,
    });
}
